<script>
import config from "../../config";
import { commonService} from "../../services";
import { error_message, success_message } from "../../Helper/helper";
import { required, email, sameAs, numeric } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      config: config,
      error: "",
      submitted:false,
      typeform: {
        app_name:"",
        vendor_name: "",
        vendor_number: "",
        email: "",
        password: "",
        confirm_password: "",
        address: "",
        terms:""
      },
    };
  },
  validations: {
    typeform: {
      app_name: {
        required,
      },
      vendor_name: {
        required,
      },
      vendor_number: {
        required,
        numeric
      },
      email: {
        required,
        email,
      },
      password: {
        required,
      },
      confirm_password: {
        required,
        sameAsPassword: sameAs("password"),
      },
      address:{
        required,
      },
      terms:{
        required,
      }
    },
  },
  methods: {
    addClient(){
      this.$v.$touch();
      if (this.$v.typeform.$invalid) {
        setTimeout(()=>{
            $('html, body').animate({
                scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
            }, 500, function() {
                $(".is-invalid:first").focus();
            });
        },500);
        return;
      }
      else{
        commonService.signup(this.typeform)
        .then(response => {
          if (response.data.code === 200) {
            success_message(response.data.message);
              this.typeform =  {
                vendor_name: "",
                vendor_number: "",
                email: "",
                password: "",
                confirm_password: "",
                address: "",
                terms: "not_accepted"
              };
              this.$v.typeform.$reset();
          } else {
            error_message(response.data.message);
          }
        });
      }
    }
  },
  
};
</script>

<template>
  <div>
    <div class="account-pages my-5 pt-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-5 login-main">
            <div class="card overflow-hidden">
              <div class="bg-soft-primary">
                <div class="row">
                  <div class="col-7">
                    <div class="text-primary p-4">
                      <h5 class="text-primary">{{ trans.get('__JSON__.Welcome Back') }} !</h5>
                      <p>Sign up to continue to {{ config.appname }} Admin Panel.</p>
                    </div>
                  </div>
                  <div class="col-5 align-self-end">
                    <img :src="config.basepath+'profile-img.png'" alt class="img-fluid" />
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div>
                  <div class="avatar-md profile-user-wid mb-4 avatar-logo-main">
                    <span class="avatar-title rounded-circle bg-light">
                      <img :src="config.applogo" alt />
                    </span>
                  </div>
                </div>

                <b-form class="p-2" @submit.prevent="addClient">
                  <!-- <div class="alert alert-danger" v-show="this.error">{{ this.error }}</div> -->
                  <slot />

                  <b-form-group
                    id="input-group-1"
                    :label="this.trans.get('__JSON__.Business Name')"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      name="app_name"
                      ref="app_name"
                      v-model="$v.typeform.app_name.$model"
                      type="text"
                      :placeholder="this.trans.get('__JSON__.Enter Business Name')"
                      :class="{ 'is-invalid':  $v.typeform.app_name.$error }"
                    ></b-form-input>
                    <div v-if="$v.typeform.app_name.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.app_name.required"
                      >{{ trans.get('__JSON__.Please enter business name') }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group
                    id="input-group-1"
                    :label="this.trans.get('__JSON__.Your Name')"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      name="vendor_name"
                      ref="vendor_name"
                      v-model="$v.typeform.vendor_name.$model"
                      type="text"
                      :placeholder="this.trans.get('__JSON__.Enter Your Name')"
                      :class="{ 'is-invalid':  $v.typeform.vendor_name.$error }"
                    ></b-form-input>
                    <div v-if="$v.typeform.vendor_name.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.vendor_name.required"
                      >{{ trans.get('__JSON__.Please enter your name') }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group
                    id="input-group-1"
                    :label="this.trans.get('__JSON__.Email')"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      name="email"
                      ref="email"
                      v-model="$v.typeform.email.$model"
                      type="text"
                      :placeholder="this.trans.get('__JSON__.Enter email')"
                      :class="{ 'is-invalid':  $v.typeform.email.$error }"
                    ></b-form-input>
                    <div v-if="$v.typeform.email.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.email.required"
                      >{{ trans.get('__JSON__.Please enter email') }}</span>
                      <span
                        v-if="!$v.typeform.email.email"
                      >{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group
                    id="input-group-1"
                    :label="this.trans.get('__JSON__.Contact Number')"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      maxlength="15"
                      minlength="12"
                      name="vendor_number"
                      ref="vendor_number"
                      v-model="$v.typeform.vendor_number.$model"
                      type="text"
                      :placeholder="this.trans.get('__JSON__.Enter Contact Number')"
                      :class="{ 'is-invalid':  $v.typeform.vendor_number.$error }"
                    ></b-form-input>
                    <div v-if="$v.typeform.vendor_number.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.vendor_number.required"
                      >{{ trans.get('__JSON__.Please enter contact number') }}</span>
                      <span
                        v-if="!$v.typeform.vendor_number.numeric"
                      >{{ trans.get('__JSON__.This value should be a valid number') }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group
                    id="input-group-1"
                    :label="this.trans.get('__JSON__.Address')"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      name="address"
                      ref="address"
                      v-model="$v.typeform.address.$model"
                      type="text"
                      :placeholder="this.trans.get('__JSON__.Enter Address')"
                      :class="{ 'is-invalid':  $v.typeform.address.$error }"
                    ></b-form-input>
                    <div v-if="$v.typeform.address.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.address.required"
                      >{{ trans.get('__JSON__.Please enter address') }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group
                    id="input-group-2"
                    :label="this.trans.get('__JSON__.Password')"
                    label-for="input-2"
                  >
                    <b-form-input
                      id="input-2"
                      v-model="$v.typeform.password.$model"
                      name="password"
                      type="password"
                      :placeholder="this.trans.get('__JSON__.Enter password')"
                      :class="{ 'is-invalid':  $v.typeform.password.$error  }"
                    ></b-form-input>
                    <div v-if="$v.typeform.password.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.password.required"
                      >{{ trans.get('__JSON__.Please enter password')}}</span>
                    </div>
                  </b-form-group>

                  <b-form-group
                    id="input-group-2"
                    :label="this.trans.get('__JSON__.Confirm Password')"
                    label-for="input-2"
                  >
                    <b-form-input
                      id="input-2"
                      v-model="$v.typeform.confirm_password.$model"
                      name="confirm_password"
                      type="password"
                      :placeholder="this.trans.get('__JSON__.Re-enter password')"
                      :class="{ 'is-invalid':  $v.typeform.confirm_password.$error  }"
                    ></b-form-input>
                    <div v-if="$v.typeform.confirm_password.$error" class="invalid-feedback">
                      <span
                        v-if="!$v.typeform.confirm_password.required"
                      >{{ trans.get('__JSON__.Please re enter your password')}}</span>
                      <span
                          v-else-if="!$v.typeform.confirm_password.sameAsPassword"
                        >{{ trans.get('__JSON__.Passwords must match') }}</span>
                    </div>
                  </b-form-group>

                  <div>
                    <b-form-checkbox
                        id="terms"
                        v-model="$v.typeform.terms.$model"
                        name="terms"
                        value="accepted"
                        unchecked-value="not_accepted"
                        :class="{ 'is-invalid':  $v.typeform.terms.$error }"
                      >
                        By doing signup I Agree <a href="https://drinkspot.co/terms-of-service.shtml" target="_blank">Terms of Service</a> & <a href="https://drinkspot.co/privacy-policy.shtml" target="_blank">Privacy policy</a> of drinkspot.
                      </b-form-checkbox>
                      <div v-if="$v.typeform.terms.$error" class="invalid-feedback">
                        <span
                          v-if="!$v.typeform.terms.required"
                        >{{ trans.get('__JSON__.Please select the checkbox')}}</span>
                    </div>
                  </div><br><br>

                  <div>
                    <button id="submit"
                      class="btn btn-primary btn-block"
                      @keyup.enter="addClient"
                      submitted = true
                      :disabled="submitted"
                    >{{ trans.get('__JSON__.Signup') }}</button>
                  </div>
                  
                </b-form>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->
          </div>
          <!-- end col -->
        </div>
        
      </div>
    </div>
  </div>
</template>

